/**
 * OQ-252 — tra nhãn hành động ngược về mã, cho ô tìm của Nhật ký hoạt động.
 *
 * Từ `OQ-250`, màn hình hiện *"Thêm bản ghi DNS"* thay vì `dns.create`. Người
 * dùng gõ đúng thứ họ nhìn thấy — nhưng bản dịch nằm ở đây, phía web, còn câu
 * truy vấn chạy ở CSDL. Backend không biết một chữ tiếng Việt nào và cũng không
 * nên biết.
 *
 * Nên phía web dịch ngược trước khi gửi: quét từ điển, lấy ra những action có
 * nhãn khớp từ khoá, gửi kèm dưới dạng `qActions=id1,id2`.
 *
 * Bỏ dấu hai vế khi so. Người ta gõ "them ban ghi" nhiều không kém "thêm bản
 * ghi", nhất là khi đang vội — và một ô tìm bắt người dùng gõ đúng dấu là một ô
 * tìm hỏng một nửa.
 */

import { AUDIT_ACTIONS } from '@dnshub/shared';

/**
 * Bỏ dấu tiếng Việt để so khớp lỏng.
 *
 * `đ` phải xử lý riêng: nó không phải `d` + dấu phụ nào cả, mà là một chữ cái
 * độc lập trong bảng mã, nên `NFD` không tách nó ra như `ê` hay `ơ`.
 */
export function boDau(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd');
}

/**
 * Những audit action có **nhãn** chứa từ khoá.
 *
 * @param tuKhoa từ người dùng gõ vào ô tìm
 * @param dich   hàm dịch (`useT()`), tiêm vào để hàm này không phụ thuộc React
 */
export function actionKhopNhan(tuKhoa: string, dich: (key: string) => string): string[] {
  const can = boDau(tuKhoa.trim());
  if (!can) return [];

  return (AUDIT_ACTIONS as readonly string[]).filter((action) => {
    const nhan = dich(`action.${action}`);
    /*
     * Thiếu bản dịch thì `t()` trả về chính khoá. So tiếp sẽ khớp bừa: gõ
     * "action" ra toàn bộ nhật ký. `oq-250` đã canh cho không thiếu khoá nào,
     * nhưng ở đây vẫn phải tự vệ — hàm này không được phép tin điều đó.
     */
    if (nhan === `action.${action}`) return false;
    return boDau(nhan).includes(can);
  });
}
